/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Company } from "./Company";
import {
  CompanyFromJSON,
  CompanyFromJSONTyped,
  CompanyToJSON,
  CompanyToJSONTyped,
} from "./Company";
import type { CustomerSpecificPricingAgreement } from "./CustomerSpecificPricingAgreement";
import {
  CustomerSpecificPricingAgreementFromJSON,
  CustomerSpecificPricingAgreementFromJSONTyped,
  CustomerSpecificPricingAgreementToJSON,
  CustomerSpecificPricingAgreementToJSONTyped,
} from "./CustomerSpecificPricingAgreement";
import type { CustomerSpecificCoverageResult } from "./CustomerSpecificCoverageResult";
import {
  CustomerSpecificCoverageResultFromJSON,
  CustomerSpecificCoverageResultFromJSONTyped,
  CustomerSpecificCoverageResultToJSON,
  CustomerSpecificCoverageResultToJSONTyped,
} from "./CustomerSpecificCoverageResult";

/**
 *
 * @export
 * @interface CompanyCustomerSpecificPricing
 */
export interface CompanyCustomerSpecificPricing {
  /**
   *
   * @type {Company}
   * @memberof CompanyCustomerSpecificPricing
   */
  company: Company;
  /**
   *
   * @type {Array<CustomerSpecificPricingAgreement>}
   * @memberof CompanyCustomerSpecificPricing
   */
  agreements: Array<CustomerSpecificPricingAgreement>;
  /**
   *
   * @type {CustomerSpecificCoverageResult}
   * @memberof CompanyCustomerSpecificPricing
   */
  agreedCoverage: CustomerSpecificCoverageResult;
}

/**
 * Check if a given object implements the CompanyCustomerSpecificPricing interface.
 */
export function instanceOfCompanyCustomerSpecificPricing(
  value: object,
): value is CompanyCustomerSpecificPricing {
  if (!("company" in value) || value["company"] === undefined) return false;
  if (!("agreements" in value) || value["agreements"] === undefined)
    return false;
  if (!("agreedCoverage" in value) || value["agreedCoverage"] === undefined)
    return false;
  return true;
}

export function CompanyCustomerSpecificPricingFromJSON(
  json: any,
): CompanyCustomerSpecificPricing {
  return CompanyCustomerSpecificPricingFromJSONTyped(json, false);
}

export function CompanyCustomerSpecificPricingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyCustomerSpecificPricing {
  if (json == null) {
    return json;
  }
  return {
    company: CompanyFromJSON(json["company"]),
    agreements: (json["agreements"] as Array<any>).map(
      CustomerSpecificPricingAgreementFromJSON,
    ),
    agreedCoverage: CustomerSpecificCoverageResultFromJSON(
      json["agreedCoverage"],
    ),
  };
}

export function CompanyCustomerSpecificPricingToJSON(
  json: any,
): CompanyCustomerSpecificPricing {
  return CompanyCustomerSpecificPricingToJSONTyped(json, false);
}

export function CompanyCustomerSpecificPricingToJSONTyped(
  value?: CompanyCustomerSpecificPricing | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    company: CompanyToJSON(value["company"]),
    agreements: (value["agreements"] as Array<any>).map(
      CustomerSpecificPricingAgreementToJSON,
    ),
    agreedCoverage: CustomerSpecificCoverageResultToJSON(
      value["agreedCoverage"],
    ),
  };
}
